import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { productosPath } from 'src/app/shared/helpers/constants';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean
  ) {}

  ngOnInit() {}

  onGoToProduct() {
    this.router.navigate(
      [productosPath.path]
      // ,{
      // relativeTo: this.route
      // }
    );
    this.dialogRef.close();
  }
}
